import { render, staticRenderFns } from "./fclRealList.vue?vue&type=template&id=f15993f6&scoped=true&"
import script from "./fclRealList.vue?vue&type=script&lang=js&"
export * from "./fclRealList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15993f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f15993f6')) {
      api.createRecord('f15993f6', component.options)
    } else {
      api.reload('f15993f6', component.options)
    }
    module.hot.accept("./fclRealList.vue?vue&type=template&id=f15993f6&scoped=true&", function () {
      api.rerender('f15993f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/components/list/fclRealList.vue"
export default component.exports